<div class="tooltip-content" [@showHide]="isShow ? 'opened' : 'closed'">
  {{ tTooltip }}
</div>
